import { useEffect } from 'react'
import { highlightWithin } from './renderers/domHighlight'

/**
 * Keeps `term` marked inside a subtree that renders on its own schedule (#755).
 *
 * A table parsed client-side or a text block that mounts later is not there
 * when the term arrives, so the subtree is observed and re-marked whenever it
 * changes. The marking's own mutations are discarded before the observer can
 * see them, which is what keeps this from looping.
 */
export function useDomHighlight(rootRef: React.RefObject<HTMLElement | null>, term: string): void {
  useEffect(() => {
    const root = rootRef.current
    if (!root) return

    const observer = new MutationObserver(() => apply())
    const apply = () => {
      highlightWithin(root, term)
      observer.takeRecords()
    }

    apply()
    observer.observe(root, { childList: true, subtree: true })
    return () => {
      observer.disconnect()
      highlightWithin(root, '')
    }
  }, [rootRef, term])
}
